import { CSSInterpolation } from '@emotion/css';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { IntegratedMessaingTrackingPrefixes } from '@frontend/integrated-messaging';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';

interface CreateNewTemplateProps {
  onClick: () => void;
  currentTab: string;
  customCss?: CSSInterpolation;
}

export const CreateNewTemplateCTA = ({ onClick, currentTab, customCss }: CreateNewTemplateProps) => {
  const { t } = useTranslation('integrated-messaging');

  return (
    <NakedButton
      css={[{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px' }, customCss]}
      onClick={onClick}
      tabIndex={0}
      trackingId={`${IntegratedMessaingTrackingPrefixes.TemplateSelector}-create-new-template-button`}
    >
      <Icon name='plus-small' css={{ color: theme.colors.primary50 }} />
      <Text color='primary' weight='bold' size='medium'>
        {t('New {{type}} Template', { type: currentTab })}
      </Text>
    </NakedButton>
  );
};
